import React, { useState } from 'react'
import { PageContent } from '@/components/shared/page-content'
import { HeaderSection } from '@/components/shared/header-section'
import { useQuery } from '@apollo/client'
import { GET_INVOICED_ORDERS } from './InvoiceQueries'
import { DataTableManual } from '@/components/shared/data-table-manual/data-table-manual'
import { columns } from './components/columns'
import { DataTableToolbar } from '@/components/shared/data-table-manual/data-table-toolbar-manual'
import { SortingState } from '@tanstack/react-table'

export default function Invoices() {
  const [pageIndex, setPageIndex] = useState(0)
  const [pageSize, setPageSize] = useState(20)

  const [sorting, setSorting] = useState<SortingState>([
    {
      id: 'createdAt',
      desc: true,
    },
  ])
  const [searchTerm, setSearchTerm] = useState('')

  // Prepare query variables
  const queryVariables = React.useMemo(() => {
    return {
      take: pageSize,
      skip: pageIndex * pageSize,
      searchTerm: searchTerm || '',
      orderBy: sorting.map(sort => ({
        [sort.id]: sort.desc ? 'desc' : 'asc',
      })),
    }
  }, [pageSize, pageIndex, searchTerm, sorting])

  const { data, loading } = useQuery(GET_INVOICED_ORDERS, {
    variables: queryVariables,
    fetchPolicy: 'network-only', // Always fetch from network when variables change
  })

  // Reset pagination when search changes
  React.useEffect(() => {
    setPageIndex(0)
  }, [searchTerm])

  const handlePaginationChange = (updater: any) => {
    const newPagination = updater({
      pageIndex,
      pageSize,
    })
    setPageIndex(newPagination.pageIndex)
    setPageSize(newPagination.pageSize)
  }

  const toolbarConfig = {
    search: {
      onSearch: (search: string) => setSearchTerm(search),
      onFilter: () => {},
      placeholder: 'Search invoices...',
      accessor: 'searchTerm',
    },
    columns: [],
  }

  return (
    <PageContent>
      <HeaderSection
        title="Invoices"
        subtitle="Orders with an assigned invoice"
      />
      <div className="mt-8">
        <DataTableManual
          data={data?.findManyOrder || []}
          columns={columns}
          pageIndex={pageIndex}
          pageSize={pageSize}
          rowCount={data?.findManyOrderCount || 0}
          onPaginationChange={handlePaginationChange}
          onSortingChange={setSorting}
          onColumnFiltersChange={() => {}}
          isLoading={loading}
          toolbar={table => (
            <DataTableToolbar table={table} config={toolbarConfig} />
          )}
          defaultSorting={[
            {
              id: 'createdAt',
              desc: true,
            },
          ]}
        />
      </div>
    </PageContent>
  )
}
